import { Address, Td, Tr } from '../../../components';
import { ContactInfoCell } from '../../../components/tables';
import { backendNameToLabel } from '../../../utils/formatting';
import { ActionDropdown, LabelValueCell } from '../../../components/table-2.0';
import { CustomDropdownItem, useToggle } from '@oforce/global-components';
import UpdateVehicleStakeholder from '../../vehicleStakeholder/components/UpdateVehicleStakeholder';
import RemoveVehicleStakeholder from '../../vehicleStakeholder/components/RemoveVehicleStakeholder';

export default function VehicleStakeholderRow({ stakeholder }) {
  const [editOpen, toggleEdit] = useToggle();
  const [deleteOpen, toggleDelete] = useToggle();

  const { id, types, name, phone, email } = stakeholder;
  const cleanTypes = types?.join(', ');

  return (
    <>
      <Tr key={id}>
        <Td>
          <LabelValueCell label={name} value={backendNameToLabel(cleanTypes)} />
        </Td>
        <Td>
          <div className="d-flex flex-column align-items-start">
            <ContactInfoCell email={email} mobilePhone={phone} />
          </div>
        </Td>
        <Td>
          <Address stakeholder={stakeholder} />
        </Td>
        <Td>
          <ActionDropdown>
            <CustomDropdownItem color="info" icon={['far', 'pen']} onClick={toggleEdit}>
              Edit
            </CustomDropdownItem>
            <CustomDropdownItem color="danger" icon={['far', 'trash-alt']} onClick={toggleDelete}>
              Remove
            </CustomDropdownItem>
          </ActionDropdown>
        </Td>
      </Tr>
      {editOpen && <UpdateVehicleStakeholder stakeholder={stakeholder} isOpen={editOpen} toggle={toggleEdit} />}
      {deleteOpen && <RemoveVehicleStakeholder stakeholder={stakeholder} isOpen={deleteOpen} toggle={toggleDelete} />}
    </>
  );
}
